import React, { useState } from "react";
import { isValidEmail } from "../utils/EmailValidation";
import { useApi } from "../Api/ApiContext";
import { useAsyncFn } from "react-use";
import {
  Col,
  Form,
  FormFeedback,
  FormText,
  FormGroup,
  Alert,
  Button,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { Main } from "../Layout";
import Input from "../component/Input";

const DownloadOrder = () => {
  const { getDedicace } = useApi();
  const [{ loading, error, value }, getDedicaceFile] = useAsyncFn(
    (orderRef, email) => getDedicace(orderRef, email)
  );
  const [orderRef, setOrderRef] = useState("");
  const [email, setEmail] = useState(undefined);
  const [emailError, setEmailError] = useState(false);

  const handleChange = (e, setter) => {
    setter(e.target.value);
    setEmailError(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (orderRef && isValidEmail(email)) {
      getDedicaceFile(orderRef, email);
    }
    if (!isValidEmail(email)) {
      setEmailError(true);
    }
  };

  if (loading) {
    return (
      <Main>
        <Row className={"my-3 my-lg-3"}>
          <Col lg={6} className={"mx-auto"}>
            <Spinner color={"danger"} />
          </Col>
        </Row>
      </Main>
    );
  }

  if (value) {
    return (
      <Main className="my-3">
        <Row>
          <Col lg={6} className={"mx-auto"}>
            <h1 className={"fs-4 fw-bold"}>Pour télécharger votre dédicace:</h1>
            <Alert color={"info fw-bold"}>
              Cliquer sur les 3 petits points situés en bas à droite sur la
              vidéo puis cliquer sur télécharger.
            </Alert>
          </Col>
        </Row>
        <Row>
          <Col lg={6} className={"mx-auto"}>
            <video controls width="100%">
              <source src={value} />
            </video>
          </Col>
        </Row>
      </Main>
    );
  }
  return (
    <Main className={"my-3"}>
      <Row>
        <Col tag={"h1"} lg={6} className={"fs-5 mx-auto"}>
          Pour accéder à votre commande veuillez renseigner les informations
          ci-dessous:
        </Col>
      </Row>
      {error && (
        <Row>
          <Col lg={6} className={"mx-auto"}>
            <Alert color={"danger"}>
              Une erreur est survenue. Veuillez réessayer plus tard.
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <Form>
            <FormGroup>
              <Label for={"email"}>
                L'adresse email ayant servi à la commande
              </Label>
              <Input
                className={"form-control"}
                id={"email"}
                type={"email"}
                name={"email"}
                value={email}
                invalid={emailError}
                onChange={(e) => handleChange(e, setEmail)}
              />
              <FormFeedback>Adresse email incorrecte.</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for={"orderRef"}>La référence de la commande</Label>
              <Input
                className={"form-control"}
                id={"orderRef"}
                type={"text"}
                name={"orderRef"}
                value={orderRef}
                onChange={(e) => handleChange(e, setOrderRef)}
              />
              <FormText>
                La référence de la commande se trouve dans le mail de
                confirmation de la commande.
              </FormText>
            </FormGroup>
            <Row className={"justify-content-center justify-content-sm-end"}>
              <Col xs={6} sm={2}>
                <Button
                  className={"w-100"}
                  color={"primary"}
                  disabled={!email || !orderRef}
                  onClick={handleSubmit}
                >
                  Valider
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Main>
  );
};

export default DownloadOrder;
